import React, {Component} from "react";
import Translate from "../../../../../../../components/Translate";
import ButtonMessageEdit from "./components/ButtonMessageEdit";
import TextMessageEdit from "./components/TextMessageEdit";
import {
    getClientHardcodedMessages,
    getClientHardcodedMessageStatusData,
    updateHardcodedMessageStatus
} from "../../../../../../../services/company/api";
import "./components/HardcodedMessages.css";

const BOTTOM_GAP = 56;
const MIN_LIST_HEIGHT = 220;

class HardcodedMessagesBottomTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hardCodedMessages: {},
            hardCodedMessagesStatusData: {},
            listMaxHeight: null,
            columnsMaxHeight: null,
            columnsStacked: false
        }

        this.columnsRef = React.createRef();
        this.listRef = React.createRef();
    }

    componentDidMount() {
        const {client} = this.props;
        getClientHardcodedMessages(client.id)
            .then((hardCodedMessages) => {
                this.setState({
                    loading: false, hardCodedMessages,
                }, this.updateLayoutHeight);
            });
        getClientHardcodedMessageStatusData(client.id)
            .then((data) => {
                this.setState({
                    loading: false, hardCodedMessagesStatusData: data,
                });
            });

        this.updateLayoutHeight();
        window.addEventListener('resize', this.updateLayoutHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateLayoutHeight);
    }

    /**
     * A `100vh - constant` cap can't know how much room the dashboard header and
     * the tab rows above already took, so measure where the list actually starts
     * and give it whatever is left — that keeps the page itself from scrolling.
     * The bottom edge comes from the nearest scrolling ancestor (the dashboard
     * scrolls its own container, not the window) and has to leave room for that
     * container's own bottom padding, which is what still overflowed before.
     */
    getScrollParent = (node) => {
        let el = node && node.parentElement;

        while (el && el !== document.body) {
            const {overflowY} = window.getComputedStyle(el);
            if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
                return el;
            }
            el = el.parentElement;
        }

        return null;
    };

    updateLayoutHeight = () => {
        if (!this.listRef.current || !this.columnsRef.current) return;

        const columns = this.columnsRef.current;
        const list = this.listRef.current;
        const columnEls = Array.from(columns.querySelectorAll('.hcm-column'));
        const columnsStacked = columnEls.length > 1
            && columnEls[1].getBoundingClientRect().top > columnEls[0].getBoundingClientRect().top;

        const scrollParent = this.getScrollParent(columns);
        let bottom = window.innerHeight;
        let parentPadding = 0;

        if (scrollParent) {
            const rect = scrollParent.getBoundingClientRect();
            bottom = Math.min(bottom, rect.bottom);
            parentPadding = parseFloat(window.getComputedStyle(scrollParent).paddingBottom) || 0;
        }

        const top = columnsStacked
            ? columns.getBoundingClientRect().top
            : list.getBoundingClientRect().top;
        const available = bottom - top - parentPadding - BOTTOM_GAP;
        const maxHeight = Math.max(MIN_LIST_HEIGHT, available);

        const nextState = columnsStacked
            ? {columnsStacked, columnsMaxHeight: maxHeight, listMaxHeight: null}
            : {columnsStacked, columnsMaxHeight: null, listMaxHeight: maxHeight};

        if (
            this.state.columnsStacked !== nextState.columnsStacked ||
            this.state.columnsMaxHeight !== nextState.columnsMaxHeight ||
            this.state.listMaxHeight !== nextState.listMaxHeight
        ) {
            this.setState(nextState);
        }
    };

    handleCheckboxChange = (type) => {
        const {hardCodedMessagesStatusData} = this.state;
        const {client} = this.props;

        const currentStatus = hardCodedMessagesStatusData[type] ? hardCodedMessagesStatusData[type] : false;

        updateHardcodedMessageStatus(client.id, type, !currentStatus).then(() => {
            this.setState((prevState) => ({
                hardCodedMessagesStatusData: {
                    ...prevState.hardCodedMessagesStatusData,
                    [type]: !currentStatus,
                },
            }));
        });
    };

    messageTypeRender(type, locale) {
        const {hardCodedMessages, config, client} = this.props;
        const {hardCodedMessagesStatusData} = this.state;

        if (config.hardCodedMessagesTypeButtons.includes(type)) {
            return <ButtonMessageEdit
                        type={type}
                        value={hardCodedMessages[type][locale]}
                        updateMessage={this.props.updateHardCodedMessages(type, locale)}
                        user={this.props.user}
            />;
        }

        return <TextMessageEdit handleCheckboxChange={this.handleCheckboxChange} client={client} type={type}
                                hardCodedMessagesStatusData={hardCodedMessagesStatusData}
                                value={hardCodedMessages[type][locale]}
                                updateMessage={this.props.updateHardCodedMessages(type, locale)}/>;
    }

    render() {
        const {activeTabId, localeOption, config, client, features} = this.props;

        const {hardCodedMessagesTypes} = config;

        const hardCodedMessagesTextTypes = hardCodedMessagesTypes.filter((item) => {
            if (!item.includes('TEXT')) return false;

            if (item === 'CHOOSE_SKILL_TEXT' && !features.includes(config.features.SKILLS)) {
                return false;
            }

            if (item === 'BLOCKED_TEXT' && !features.includes(config.features.BLACK_LIST)) {
                return false;
            }

            if (item === 'REMINDER_TEXT' && !features.includes(config.features.REMINDERS_NO_AI)) {
                return false;
            }

            if (item === 'OUT_WORKING_HOURS_TEXT' && !features.includes(config.features.WORKING_HOURS)) {
                return false;
            }

            if (item === 'AI_ATTACHMENT_ANSWER_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'AI_NOT_SUPPORTED_LANGUAGE_ANSWER_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'AI_WELCOME_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'AI_ERROR_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'AI_RATE_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'DONT_KNOW_TEXT' && !features.includes(config.features.TEXT_ACTION_NO_AI)) {
                return false;
            }

            if (item === 'SESSION_EXPIRE_TEXT' && !features.includes(config.features.EXPIRATION_TIME)) {
                return false;
            }


            if ((client.type === config.companyTypeMap.scenario
                && item === 'AI_ERROR_TEXT')) {
                return false;
            }

            if ((client.type === config.companyTypeMap.scenario
                && item === 'RATE_AI_TEXT')) {
                return false;
            }

            if (client.type === config.companyTypeMap.scenario
                && item === 'AI_WELCOME_TEXT') {
                return false;
            }

            if (client.type === config.companyTypeMap.scenario
                && item === 'AI_ATTACHMENT_ANSWER_TEXT') {
                return false;
            }

            if (client.type === config.companyTypeMap.scenario
                && item === 'AI_NOT_SUPPORTED_LANGUAGE_ANSWER_TEXT') {
                return false;
            }

            if (client.type === config.companyTypeMap.smart
                && (item === 'DONT_KNOW_TEXT' || item === 'CHOOSE_FOLLOWING_TEXT')) {
                return false;
            }

            return true;
        });

        const hardCodedMessagesButtonTypes = hardCodedMessagesTypes.filter((item) => {
            if (item.includes('TEXT')) return false;

            if (item === 'REMINDER_BUTTON' && !features.includes(config.features.REMINDERS_NO_AI)) {
                return false;
            }

            return true;
        });

        if (activeTabId === -1) {
            return (<div/>);
        }

        const {listMaxHeight, columnsMaxHeight, columnsStacked} = this.state;
        const listStyle = listMaxHeight ? {maxHeight: listMaxHeight + 'px'} : undefined;
        const columnsStyle = columnsMaxHeight ? {maxHeight: columnsMaxHeight + 'px'} : undefined;

        return (
            <div
                className={`hcm-columns ${columnsStacked ? 'hcm-columns--stacked' : ''}`}
                ref={this.columnsRef}
                style={columnsStyle}
            >
                {/* a restricted plan can filter a whole column empty — don't leave
                    a heading standing over nothing */}
                {hardCodedMessagesTextTypes.length > 0 && (
                    <div className="hcm-column">
                        <h3 className="hcm-column__title"><Translate text="messages"/></h3>
                        <ul className="hcm-list" ref={this.listRef} style={listStyle}>
                            {hardCodedMessagesTextTypes.map((type) => (
                                <li className="hcm-item" key={type}>
                                    <span className="hcm-item__label"><Translate text={type}/></span>
                                    {this.messageTypeRender(type, localeOption.value)}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {hardCodedMessagesButtonTypes.length > 0 && (
                    <div className="hcm-column">
                        <h3 className="hcm-column__title"><Translate text="buttons"/></h3>
                        <ul className="hcm-list" style={listStyle}>
                            {hardCodedMessagesButtonTypes.map((type) => (
                                <li className="hcm-item" key={type}>
                                    <span className="hcm-item__label"><Translate text={type}/></span>
                                    {this.messageTypeRender(type, localeOption.value)}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    }

}

export default HardcodedMessagesBottomTab;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/HardcodedMessagesBottomTab.jsx